export default __webpack_public_path__ + "static/media/clear.8bcde0d3.png";